import { useEffect, useState } from "react";
import useMediaNavigation from "../hooks/useMediaNavigation";
import { MarkerMetadata } from "../../map/components/marker/MarkerComponents";
import MediaSlide from "./MediaSlide";
import { mediaShell } from "../../../styles/mediaShell";

function MediaSlideshow({ marker, label, mediaList, onEdit, canEdit, loading = false, onClose }) {
    const [totalPages, setTotalPages] = useState(1);

    useEffect(() => {
        const newTotalPages = 1 + (mediaList?.length || 0);
        setTotalPages(newTotalPages);
    }, [mediaList]);

    const { currentPage, goNext, goPrev } = useMediaNavigation(totalPages, loading);

    const calculatedTotalPages = 1 + (mediaList?.length || 0);
    const slideNumber = (() => {
        if (loading) {
            return "読み込み中...";
        } else if (mediaList && calculatedTotalPages > 0) {
            return `${currentPage + 1} / ${calculatedTotalPages}`;
        } else {
            return "1 / 1";
        }
    })();

    const renderPage = () => {
        if (loading) {
            return (
                <div className={`${mediaShell.slide} ${mediaShell.slideLoading}`}>
                    <div className={mediaShell.loadingContainer}>
                        <div className={mediaShell.loadingSpinner}></div>
                        <div className={mediaShell.loadingText}>メディアを読み込み中...</div>
                    </div>
                </div>
            );
        }

        if (currentPage === 0) {
            return (
                <div className={`${mediaShell.slide} ${mediaShell.slideMetadata}`}>
                    <MarkerMetadata marker={marker} label={label} onEdit={onEdit} canEdit={canEdit} />
                </div>
            );
        }
        const currentMedia = mediaList[currentPage - 1];
        return (
            <div className={`${mediaShell.slide} ${mediaShell.slideContent}`}>
                <MediaSlide
                    key={`media-slide-${currentPage}-${currentMedia?.id}`}
                    media={currentMedia}
                />
            </div>
        );
    };

    return (
        <div className={mediaShell.slideshowWrapper}>
            {onClose && (
                <button
                    type="button"
                    className={mediaShell.closeButton}
                    onClick={onClose}
                    aria-label="閉じる"
                >
                    <span className="material-symbols-outlined text-icon-md">close</span>
                </button>
            )}

            {currentPage > 0 && (
                <div
                    className={`${mediaShell.navArea} ${mediaShell.navLeft}`}
                    onClick={goPrev}
                    title="前のページへ"
                >
                    <div className={mediaShell.navArrow}>
                        <span className="material-symbols-outlined">arrow_back</span>
                    </div>
                </div>
            )}

            {currentPage < totalPages - 1 && (
                <div
                    className={`${mediaShell.navArea} ${mediaShell.navRight}`}
                    onClick={goNext}
                    title="次のページへ"
                >
                    <div className={mediaShell.navArrow}>
                        <span className="material-symbols-outlined">arrow_forward</span>
                    </div>
                </div>
            )}

            <div className={mediaShell.slideshow}>
                {renderPage()}
                <div className={mediaShell.counter}>
                    {slideNumber}
                </div>
            </div>
        </div>
    );
}

export default MediaSlideshow;
